import React, { useEffect, useMemo } from 'react';
import { SquareReturnIcon } from '../icons';
import { enrichResultTitle } from '@atlassian/search-common';
import { CollapsedResultContentWrapper, EnlargedCollapsedResultDetail, EnlargedCollapsedResultDetailWrapper, EnlargedIconContainer, EnlargedResultDetail, EnlargedResultContentWrapper, ResultLabel, EnlargedResultTitleContainer, EnlargedReturnIconContainer } from './search-result.styled';

/**
 * This component is an alternative to the default result content component.
 * It displays the result content in a taller component. It displays the metadata underneath
 * the title, and show the additional metadata on the right.
 */
export var EnlargedSearchResultContent = function EnlargedSearchResultContent(_ref) {
  var icon = _ref.icon,
    label = _ref.label,
    title = _ref.title,
    highlightedTitle = _ref.highlightedTitle,
    meta = _ref.meta,
    additionalMeta = _ref.additionalMeta,
    isCollapsed = _ref.isCollapsed,
    isKeyboardHighlighted = _ref.isKeyboardHighlighted,
    _ref$returnIcon = _ref.returnIcon,
    returnIcon = _ref$returnIcon === void 0 ? 'onHighlight' : _ref$returnIcon;
  var contentRef = React.useRef(null);
  var showReturnIcon = useMemo(function () {
    return returnIcon === 'always' || returnIcon === 'onHighlight' && isKeyboardHighlighted;
  }, [isKeyboardHighlighted, returnIcon]);
  useEffect(function () {
    var _contentRef$current;
    if (isKeyboardHighlighted && (_contentRef$current = contentRef.current) !== null && _contentRef$current !== void 0 && _contentRef$current.scrollIntoView) {
      contentRef.current.scrollIntoView({
        behavior: 'auto',
        block: 'nearest'
      });
    }
  }, [isKeyboardHighlighted]);
  return /*#__PURE__*/React.createElement(EnlargedResultContentWrapper, {
    ref: contentRef,
    isCollapsed: isCollapsed,
    isKeyboardHighlighted: isKeyboardHighlighted
  }, /*#__PURE__*/React.createElement(EnlargedIconContainer, null, icon), /*#__PURE__*/React.createElement(CollapsedResultContentWrapper, {
    "data-testid": "collapsed-result-view"
  }, /*#__PURE__*/React.createElement(EnlargedResultTitleContainer, {
    isCollapsed: true
  }, /*#__PURE__*/React.createElement("span", {
    title: title,
    className: "SearchDialogResultTitle"
  }, highlightedTitle ? enrichResultTitle(highlightedTitle) : title), typeof label === 'string' ? /*#__PURE__*/React.createElement(ResultLabel, {
    title: title
  }, label) : label), meta && /*#__PURE__*/React.createElement(EnlargedCollapsedResultDetailWrapper, null, /*#__PURE__*/React.createElement(EnlargedCollapsedResultDetail, null, meta))), additionalMeta && /*#__PURE__*/React.createElement(EnlargedResultDetail, null, additionalMeta), showReturnIcon && /*#__PURE__*/React.createElement(EnlargedReturnIconContainer, null, /*#__PURE__*/React.createElement(SquareReturnIcon, null)));
};